"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activities.panel.all': '所有活动',
    'activities.panel.telegram': 'Telegram',
    'activities.panel.whatsapp': 'WhatsApp',
    'activities.panel.noLogs': '没有活动可显示。',
    'activities.panel.noData': '没有可用的频道数据。',
    'activities.panel.groups': '群组',
    'activities.panel.channels': '频道/群组',
    'activities.panel.inboxes': '收件筱',
    'activities.panel.trackingEnabled': '跟踪已启用',
    'activities.panel.connectionActive': '连接活跃',
    'activities.panel.critical': '严重',
    'activities.panel.criticalDetected': '检测到严重问题',
    'activities.panel.noAlerts': '无警报',
    'activities.panel.requiresAction': '需要操作',
    'activities.panel.spamQueue': '垃圾邮件/队列',
    'activities.panel.warning': '警告',
    'activities.panel.noWarnings': '无警告',
    'activities.panel.status': '状态',
    'activities.panel.status.good': '良好',
    'activities.panel.status.warning': '警告',
    'activities.panel.status.danger': '危险',
    'activities.panel.lastSync': '上次同步',
    'activities.panel.neverSynced': '从未',
    'activities.panel.justNow': '刚刚',
    'activities.panel.minutesAgo': '分钟前',
    'activities.panel.hoursAgo': '小时前',
    'activities.panel.daysAgo': '天前',
};
